import authentication from '../middleware/authentication'
const FormPushMessages = () => import(/* webpackChunkName: "static/js/chunks/companySetting" */'../../views/lineChat/FormPushMessages')

const formPushLineMessagesResponseRoutes = {
  path: '/line-push-messages',
  name: 'FormPushMessages',
  component: FormPushMessages,
  meta: {
    middleware: authentication,
    layout: 'main',
    pageTitle: 'ブロードキャスト'
  }
}

export default formPushLineMessagesResponseRoutes
